export default __webpack_public_path__ + "static/media/sounds/maze_practice_option_library_alyx.mp3";